<template>
  <v-select @change="classSelected()" item-text="name" rounded dense outlined v-model="selectedClass" :items="classes"
    label="Class" multiple return-object>
    <template v-slot:item="{item, attrs, on}">
      <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
        <v-list-item-action>
          <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            <v-row no-gutters align="center">
              {{ item.name }}
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-slot:selection="{ item, index }">
      <v-chip small v-if="index < 1">
        <span>{{ item.name }}</span>
      </v-chip>
      <span v-if="index === 1" class="grey--text text-caption">
        <span v-if="(selectedClass.length - 1) === 1">(+{{ selectedClass.length - 1 }} other)</span>
        <span v-else>(+{{ selectedClass.length - 1 }} others)</span>
      </span>
    </template>
  </v-select>
</template>

<script>
import classService from "@/modules/Classes/service.js";
export default {
  name: 'department-dropbox',
  props: ['ClassName'],
  data(){
    return {
      classes: [],
      selectedClass: [],
    }
  },
  created(){
    this.getClass()
    if(this.ClassName){
      this.getClassByName()
    }
  },
  methods: {
    getClass(){
      return classService.getAll().then((response) => {
        let Class = response.data;
        if(Class){
          Class.map(row => {
            this.classes.push({
              name: row.name,
              id: row.id
              })
          })
        }

        return response;
      });
    },
    getClassByName(){
      return classService.getAll({search: this.ClassName}).then((response) => {
        let Class = response.data;
        if(Class){
          Class.map(row => {
            this.selectedClass.push({
              name: row.name,
              id: row.id
              })
          })
        }

        return response;
      });
    },
    classSelected(){
      let classId = []
      this.selectedClass.map(row => {
        classId.push(row.id)
      })
      this.$emit('classSelected', classId)
    }
  }
}
</script>